import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceControl: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"voice-control"} maskId="square-filled-radius-0-stroke-1-IconVoiceControl"><path d="M12.5 20H11.5V4H12.5V20Z" fill="currentColor"/><path d="M9 17H8V7H9V17Z" fill="currentColor"/><path d="M16 17H15V7H16V17Z" fill="currentColor"/><path d="M5.5 15L2 12L5.5 9V15Z" fill="currentColor"/><path d="M22 12L18.5 15V9L22 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVoiceControl;
